import React from 'react';
import { ModalContextCreator } from '../actions/ContextCreators';

// This consumer passes down the main Modal State that can be shared anywhere
const connectWithModalStore = Container => props => (
    <ModalContextCreator.Consumer>
        {context => <Container {...context} {...props} />}
    </ModalContextCreator.Consumer>
);

export default connectWithModalStore;
